import { render, staticRenderFns } from "./s-section.vue?vue&type=template&id=07026365"
import script from "./s-section.vue?vue&type=script&lang=js"
export * from "./s-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports